import React from "react";

const NotFound: React.FC = () => (
  <div className="h-screen w-screen flex flex-row justify-center items-center bg-[#111]">
    <section className="flex-1 h-screen flex justify-center items-center flex-col bg-[#111] px-8 text-center text-[#075089]">
      <h1 className="text-5xl py-8 text-[#D9D9DA]">Está Página Tá Gato</h1>
      <p className="text-white/70">
        O sistema neste momento está em via de desenvolvimento. Para mais
        informações ligue para os contactos encontrados na página principal.
      </p>
    </section>

    <section
      className="flex-1 h-screen hidden md:flex justify-center items-center text-white bg-cover bg-center"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, rgba(6,92,149,0.1), rgba(0,0,0,0.1)), url(/not-found.svg)",
      }}
    />
  </div>
);

export default NotFound;
